import { createContext, useCallback, useContext, useRef, useState } from "react";

const GameSessionContext = createContext(null);

export function GameSessionProvider({ children }) {
  const [navState, setNavState] = useState({
    visible: false,
    potionCounts: {},
    usedPotionIds: [],
    potionUsedThisQuestion: false,
    inputDisabled: false,
  });
  const [prepNavState, setPrepNavState] = useState({
    visible: false,
    screen: "difficulty",
  });
  const onUsePotionRef = useRef(() => {});
  const onPrepScreenChangeRef = useRef(() => {});

  const registerPotionNav = useCallback((state, onUsePotion) => {
    setNavState(state);
    onUsePotionRef.current = onUsePotion || (() => {});
  }, []);

  const registerPrepNav = useCallback((state, onScreenChange) => {
    setPrepNavState(state);
    onPrepScreenChangeRef.current = onScreenChange || (() => {});
  }, []);

  const handleUsePotion = useCallback((potionId) => {
    onUsePotionRef.current(potionId);
  }, []);

  const handlePrepScreenChange = useCallback((screen) => {
    onPrepScreenChangeRef.current(screen);
  }, []);

  return (
    <GameSessionContext.Provider
      value={{
        navState,
        prepNavState,
        registerPotionNav,
        registerPrepNav,
        handleUsePotion,
        handlePrepScreenChange,
      }}
    >
      {children}
    </GameSessionContext.Provider>
  );
}

export function useGameSessionNav() {
  const context = useContext(GameSessionContext);
  if (!context) {
    throw new Error("useGameSessionNav doit être utilisé dans GameSessionProvider.");
  }
  return context;
}
